(
  function copyrightFormInit(){
    const form = $(".copyright__form")
    const fileInput = form.find(".file-input")
    const inputs = form.find(".form-input")
    const submitButton = form.find(".submit-button")
    const filesUi = form.find(".copyright__upload__files")
    const deleteFileBtn = form.find(".copyright__file__delete")
    const emailInput = form.find(".email-input")
    const loader = form.find(".copyright__loader")

    const searchParams = new URLSearchParams(window.location.search)
    const searchParamsObs = {
      image_id: searchParams.get('image_id'),
      user_pseudo_id: searchParams.get('user_pseudo_id')
    }

    const messages = {
      formError: {
        en: '<p class="copyright__error">Error occurred. Close the form and try<br>opening it again.</p>',
        ru: '<p class="copyright__error">Произошла ошибка. Закройте форму и<br>попробуйте открыть её снова.</p>'
      },
      success: {
        en: '<div class="copyright__success"><img alt="" src="/static/img/v.svg" class="copyright__success__img"/>'+
        '<p class="copyright__success__text">Your request has been received<br>and will be reviewed soon</p></div>',
        ru: '<div class="copyright__success"><img alt="" src="/static/img/v.svg" class="copyright__success__img"/>'+
        '<p class="copyright__success__text">Ваше обращение получено <br>и скоро будет рассмотрено</p></div>',
      }
    }

    const pageLang = $("html").attr('lang')
    
    if(!searchParamsObs.image_id || !searchParamsObs.user_pseudo_id){
      $(".copyright__container")
        .empty()
        .append(messages.formError[pageLang])
    }

    const required = [
      'name',
      'owner_role',
      'source_urls',
      'email',
      'content_used_without_approvement',
      'is_authorized_owner',
      'all_data_is_valid',
      'allow_to_process_my_personal_data'
    ]

    const formValue = {}

    const insertUiFile = (name) => {
      const maxLength = 32
      const uiName = name.length < maxLength ? name : name.substring(0, 28) + '...'
      const newFile = $(`<span class="copyright__file" id="uiFile${name}">${uiName}</span>`)
      const newButton = $(`<button class="copyright__file__delete" id="${name}">`)

      newButton.on('click', onFileDelete)
      newFile.append(newButton)
      filesUi.append(newFile)
    }

    const onFileChange = (e) => {
      form.find('.copyright__file-error').addClass('copyright__hidden')

      const file = fileInput[0].files[0]

      if(!file){
        return undefined
      }

      insertUiFile(file.name)

      if(formValue.file){
        formValue.file.push(file)
        return
      }
      formValue.file=[file]

      requiredFieldsValidate(e)
    }

    const onFileDelete = (e) => {
      e.preventDefault()
      form.find('.copyright__file-error').addClass('copyright__hidden')

      const id = e.currentTarget.id
      const uiFile = $(e.currentTarget).parent()

      const updatedFiles = formValue.file.filter(file => file.name!==id)

      formValue.file = updatedFiles.length ? updatedFiles : undefined
      
      uiFile.remove()

      requiredFieldsValidate(e)
    }

    const onInputChange = (e) => {
      const value = e.target.type === 'checkbox'
      ? e.target.checked
      : e.target.value

      if(e.target.name !== 'email'){
        form.find(`input[name='${e.target.name}']`).removeClass('copyright__field__input-error')
      }

      formValue[e.target.name] = value

      requiredFieldsValidate(e)
    }

    const requiredFieldsValidate = (e) => {
      const value = e.target.type === 'checkbox'
      ? e.target.checked
      : e.target.value
      const newValue = {[e.target.name]: value}
      const newValues = Object.assign({}, formValue, newValue)
      const values = required.map(item => {
        return newValues[item]
      })

      if(values.length > values.filter(Boolean).length || !emailValidate(newValues.email)){
        return submitButton.attr('disabled', 'disabled')
      }

      return submitButton.removeAttr('disabled')
    }

    const emailValidate = (email) => {
      const regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/
      return regex.test(email)
    }

    const onEmailCheck = (e) => {
      const email = e.target.value

      if(!emailValidate(email)){
        return emailInput.addClass('copyright__field__input-error')
      }

      emailInput.removeClass('copyright__field__input-error')
    }

    const toggleFormLoading = () => {

      loader.toggleClass('copyright__hidden')
      submitButton.toggleClass('copyright__hidden')
    }

    const isOnline = () => {
      return navigator.onLine
    }
    
    const processErrors = (error) => {
      const errorObj = error.responseJSON
      const status =  error.status

      const statuses = {
        largeFiles: 413,
        validation: 422,
        noRespond: 500
      }

      if(status === statuses.largeFiles){
        toggleFormLoading()
        return form.find('.copyright__file-error').removeClass('copyright__hidden')
      }

      if((status === statuses.validation) && errorObj && errorObj.error && errorObj.error.error_codes && errorObj.error.error_codes.length){
        toggleFormLoading()
        errorObj.error.error_codes.forEach(code => {
          form.find(`input[name='${code.field}']`).addClass('copyright__field__input-error')
        })
        return
      }

      if(status === statuses.noRespond){
        toggleFormLoading()
        form.find('.copyright__server-error').removeClass('copyright__hidden')
        return
      }

      $(".copyright__container")
        .empty()
        .append(messages.formError[pageLang])

    }

    const hideFormErrors = () => {
      form.find('.copyright__server-error').addClass('copyright__hidden')
      form.find('.copyright__offline-error').addClass('copyright__hidden')
    }

    const onFormSubmit = (e) => {

      if(!isOnline()){
        return form.find('.copyright__offline-error').removeClass('copyright__hidden')
      }

      e.preventDefault()
      hideFormErrors()
      toggleFormLoading()

      const formData = new FormData()

      for (let key in formValue){
        if (key === 'file'){
          formValue[key].forEach(file => {
            formData.append("file[]", file, file.name)
          })
        } else{
          formData.append(key, formValue[key])
        }
      }

      for (let key in searchParamsObs){
        formData.append(key, searchParamsObs[key])
      }

      jQuery.ajax({
        url: 'https://feedback-api.wallpaperscraft.com/complaint/copyright',
        data: formData,
        method: 'POST',
        cache: false,
        contentType: false,
        processData: false,
        dataType: 'text',
      })
      .done(
        function(){
          $(".copyright__container")
            .empty()
            .append(
              messages.success[pageLang]
            )
        }
      )
      .fail(error => {
        processErrors(error)
      })
    }

    (
      function addEventListeners(){
        fileInput.on('change', onFileChange)
        form.on('submit', onFormSubmit)
        inputs.each(index => {
          inputs.eq(index)
          .on("change", onInputChange)
          .on("keyup", requiredFieldsValidate)
        })
        deleteFileBtn.on('click', onFileDelete)
        emailInput.on('keyup', onEmailCheck)
      }
    )();
  }
)();


// WEBPACK FOOTER //
// ./static/js/index.js